export default __webpack_public_path__ + "static/media/Wolf's Gauntlets of the Grasslands.4fd86e88.jpg";